
<template>
 <div class="grid-content bg-purple">
	<div class="box parentflex">
		<p>单片用水分时能耗(L/片)</p>
		<div class="count">
			<div class="pagebox">
				<div id="yline"></div>
			</div>
		</div>
	</div>
</div>
</template>
<script>
import {getSlice} from "@/utils/index"
export default {
   props:{
           dys:{//echarts数据
                type:Array,//类型只能是数组
                default:()=>{
                    return []
                }
            },
        }, 
  data () {
    return {
		myChart:"",
		objdata:''
    };
  },
  watch:{
      dys: {
         handler(newVal, oldVal){
			// setTimeout(()=>{
			// 	this.objdata=this.initData(newVal)
			// 	this.filldanline(this.objdata)
            // },500)
            this.objdata=this.initData(newVal)
			this.filldanline(this.objdata)
        },
        deep: true
    }
  },
  mounted() {
  },
  methods: {
      initData(obj){  //格式化需要传入的值
		let dyd=obj
		let x=(function(){
			var xAxis=[]
			for(var i=0;i<24;i++){
				xAxis.push(i+"时")
			}
			return xAxis
		})();
		let newObj={
			x:x,
			legend:[dyd[0].name,dyd[1].name],
			series:(function(){
				let series=[]
				for(let i=0;i<dyd.length;i++){
					series.push({
						name:dyd[i].name,
						type:"line",
						data:(function(){
							let _data = dyd[i].data;
                            let dataTimeArr = [];
                            // console.log("进来了")
							for (let j = 0; j < _data.length; j++) {

                                
                                dataTimeArr.push(_data[j].value)
                            }
							return dataTimeArr
						})()
					})
				}
				return series
			})()
		}
		return newObj
	 },
     filldanline(obj){  //柱状图
		let this_ = this;
        if (this_.myChart != null && this_.myChart != "" && this_.myChart != undefined) {
            this_.myChart.dispose();
        }
        this_.myChart = this_.$echarts.init(document.getElementById("yline"));
		var option = {
		    tooltip: {
		        trigger: 'axis',
		    },
		    color:["#39a0ff","#2fc25b","#DC143C"],
		    grid: {
		        left: '2%',
		        right: '2%',
		        bottom: '10%',
		        top:'8%',
		        show:true,
		        borderColor:"#dce1e7",
		        containLabel: true
		    },
		    legend: {
		        data:obj.legend,
//		        itemGap:30,
		        bottom:"5%",
		        icon: "rect",   //  这个字段控制形状  类型包括 circle，rect ，roundRect，triangle，diamond，pin，arrow，none
		        itemWidth: 12,  // 设置宽度
		        itemHeight: 2, // 设置高度
		    },
		    xAxis: [{
	            type: 'category',
	            data: obj.x,
//	            minInterval: 1,
				// splitNumber:24,
				boundaryGap:false,
	            axisLabel: {
					rotate: 40
				},
	            axisTick:{
	            	show:true
	            },
	            axisLine:{
	            	show:true
	            }
		    }],
		    yAxis: {
				type: "value",
				axisLine:{
	            	show:false
	            },
			},
		    series:obj.series
		};
		this_.myChart.setOption(option,true);
            if(this_.myChart){
                window.addEventListener("resize",function(){
                    this_.myChart.resize();
                });
            }
    }
  }
}

</script>
<style lang="scss" scoped>
.grid-content{width:100%;height:100%;overflow: hidden;background: #fff;box-shadow:0 0 10px 2px #CCD7E8;border: 1px solid #CCD7E8;border-radius: 10px; text-align: left;}
.box{width:100%;height:100%;overflow: hidden;padding: 10px;box-sizing: border-box;}
.parentflex{position: relative;padding:5px;box-sizing:border-box;background: #fff;padding-top:1px}
.parentflex>p{width:100%;height:2.2rem;line-height:2.2rem;font-size:1.4rem;padding-left:1rem;font-weight:bold;-webkit-box-sizing:border-box;box-sizing:border-box;}
.count{position:absolute;top:2.3rem;left:0;right:0;bottom:0;background:#fff;box-shadow:0 0 10px 2px #CCD7E8;box-sizing:border-box;}
.pagebox{width:100%;height:100%;overflow: hidden;}
#yline{width:100%;height:100%;overflow: hidden;}
</style>